import type { ApiMagentoConsumableMatrixItem, ApiMagentoConsumablesPackagingFormat } from "@jti/magento-types";

import type { ProductDetailsProductData } from "./aem-data";

export type ConsumableMatrixItem = ApiMagentoConsumableMatrixItem & {
  product: ProductDetailsProductData;
};

export type ConsumablesMatrixData = {
  packagingFormats: ApiMagentoConsumablesPackagingFormat[];
  items: ConsumableMatrixItem[];
};
